module.exports = __webpack_public_path__ + "img/io.io77f4edd.svg";